<template>
  <div class="tool_page">
    <div class="item">
      <div class="page_name">
        <span>{{ toolList[relation].list[arrange - 1].title }}</span>
        <div @click="gotool">
          <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"
               width="15" height="15">
            <path
                d="M704 908.8 307.2 512 704 115.2c25.6-25.6 25.6-70.4 0-96-25.6-25.6-70.4-25.6-96 0L166.4 460.8C147.2 480 140.8 492.8 140.8 512s6.4 32 19.2 51.2l441.6 441.6c25.6 25.6 70.4 25.6 96 0C729.6 979.2 729.6 934.4 704 908.8z"
                fill="#555555"></path>
          </svg>
        </div>
      </div>
      <lossless></lossless>
    </div>
    <!--    <el-tabs v-model="activeName">-->
    <!--      <el-tab-pane class="pane_item" label="无损放大" name="wsfd">-->
    <!--        <lossless></lossless>-->
    <!--      </el-tab-pane>-->
    <!--      <el-tab-pane class="pane_item" label="黑白上色" name="hbss">-->
    <!--        <sd></sd>-->
    <!--      </el-tab-pane>-->
    <!--      <el-tab-pane class="pane_item" label="图像清晰" name="txqx">-->
    <!--        <dall></dall>-->
    <!--      </el-tab-pane>-->
    <!--      <el-tab-pane class="pane_item" label="风格转换" name="fgzh">-->
    <!--        <dall></dall>-->
    <!--      </el-tab-pane>-->
    <!--      <el-tab-pane class="pane_item" label="背景移除" name="bjyc">-->
    <!--        <dall></dall>-->
    <!--      </el-tab-pane>-->
    <!--      <el-tab-pane class="pane_item" label="头像提取" name="txtq">-->
    <!--        <dall></dall>-->
    <!--      </el-tab-pane>-->
    <!--    </el-tabs>-->
  </div>
</template>

<script>
import lossless from "COMPONENTS/tool/lossless/createTool.vue"

export default {
  components: {lossless},
  data() {
    return {
      // activeName:"wsfd",
      arrange: '',
      relation: '',
      toolList: [
        {
          title: '图片编辑',relation: 0, list: [
            {
              id: 1,
              relation: 0,
              name: '极速高清无损放大',
              guide: '无损放大图片，支持2倍、3倍、4倍放大，有效改善放大后图像的噪点与锯齿问题。',
              img: require('./img/aiTool/magnify.webp'),
              title: '无损放大',
            },

            {
              id: 2,
              relation: 0,
              name: '黑白图像上色',
              guide: '通过人工智能算法，识别黑白图像内容并填充色彩，使黑白图像变得鲜活。',
              img: require('./img/aiTool/colour.webp'),
              title: '黑白上色',
            },
            {
              id: 3,
              relation: 0,
              name: '图像清晰度增强',
              guide: '利用Ai技术，智能识别图像主体以消除模糊，增强对比度和颜色，获得更清晰、更生动的视觉效果。',
              img: require('./img/aiTool/repair.webp'),
              title: '清晰增强',
            },
            {
              id: 4,
              relation: 0,
              name: '图像风格转换',
              guide: '您可以将图像转换为卡通、铅笔、彩色铅笔或哥特式油画等多种风格。',
              img: require('./img/aiTool/cartoon.webp'),
              title: '风格转换',
            },
            {
              id: 5,
              relation: 0,
              name: '图像擦除',
              guide: '快速移除照片中不需要的的物、人、文字。清理照片，美化图片',
              img: require('./img/aiTool/remove.webp'),
              title: '图像擦除',
            },

          ],
        },
        {
          title: '电商设计',relation: 1, list: [
            {
              id: 1,
              relation: 1,
              name: '背景移除',
              guide: '智能地识别图像的主体，将其视为前景并自动去除背景。适用于各种场景中的人物、动物等。',
              img: require('./img/aiTool/capture.webp'),
              title: '背景移除',
            },
            {
              id: 2,
              relation: 1,
              name: 'AI虚拟试衣  ',
              guide: '一键智能扩图，也可以对图片进行上下左右自定义像素的自动填充',
              img: require('./img/aiTool/fittingRoom.webp'),
              title: 'AI虚拟试衣 ',
            },

          ],
        },
        {
          title: '创意应用',  relation: 2, list: [
            {
              id: 1,
              relation: 2,
              name: '头像提取',
              guide: '它能够准确检测头部区域，一键裁剪并去除其他元素。',
              img: require('./img/aiTool/expansion.webp'),
              title: '头像提取',
            },

          ],
        },
        {
          title: 'AI变美', relation: 3, list: [
            {
              id: 1,
              relation: 3,
              name: '照片一键美颜',
              title: '照片一键美颜',
              mj_tool: 'oneClickBeautyTransformation',
              guide: '利用AI技术，实现完整的肖像增强，包括皮肤平滑、美白、脸部瘦身等，以达到自然的外观',
              img: require('./img/aiTool/beautify1.webp'),
              points: 1,
            },
            {
              id: 2,
              relation: 3,
              name: '人物动漫化',
              title: '人物动漫化',
              mj_tool: 'characterAnime',
              guide: '利用先进的AI技术将完整图像或照片转化为卡通或动漫效果，非常适合创建卡通化照片和卡通风格的虚拟形象',
              img: require('./img/aiTool/beautify2.webp'),
              points: 1,
            },
            {
              id: 3,
              relation: 3,
              name: '人脸滤镜',
              title: '人脸滤镜',
              mj_tool: 'emitFacefilter',
              guide: '智能识别图像内容，快速应用AI滤镜，提升图像质感，支持滤镜强度调节，轻松优化视觉效果',
              img: require('./img/aiTool/beautify3.webp'),
              points: 1,
            },
            {
              id: 4,
              relation: 3,
              name: '人脸模糊(打码)',
              title: '人脸模糊(打码)',
              mj_tool: 'emitBlurredfaces',
              guide: '利用先进的AI技术，智能识别人脸区域，一键模糊人脸，轻松保护隐私，提升图像安全性',
              img: require('./img/aiTool/beautify4.webp'),
              points: 1,
            },
            {
              id: 5,
              relation: 3,
              name: '发型编辑',
              title: '发型编辑',
              mj_tool: 'emitHairstyleeditor',
              guide: '能够精准识别人像区域，实现一键更换发型和发色。您可以选择多达数十种发型和发色组合，轻松打造您独特的个性化造型，满足不同的美发需求',
              img: require('./img/aiTool/beautify5.webp'),
              points: 1,
            },
            {
              id: 6,
              relation: 3,
              name: '表情编辑',
              title: '表情编辑',
              mj_tool: 'emitEmotioneditor',
              guide: '无论是闭嘴微笑、露齿笑、嘟嘴、还是耍酷或悲伤等十多种表情，您都可以轻松生成自然逼真的效果',
              img: require('./img/aiTool/beautify6.webp'),
              points: 1,
            },
            {
              id: 7,
              relation: 3,
              name: '年龄・性別变换',
              title: '年龄・性別变换',
              mj_tool: 'emitFaceattributeediting',
              guide: '采用先进的AI技术，智能识别人脸，实现从15岁到85岁的年龄变换，以及男性与女性之间的性别转换',
              img: require('./img/aiTool/beautify7.webp'),
              points: 1,
            },
            {
              id: 8,
              relation: 3,
              name: '人脸美颜',
              title: '人脸美颜',
              mj_tool: 'emitFacebeauty',
              guide: '拥有美白和光滑皮肤等美化特性，以及面部塑形。此外，它还提供了多种滤镜，以增强您的图像并增添艺术气息。',
              img: require('./img/aiTool/beautify8.webp'),
              points: 1,
            },
            {
              id: 9,
              relation: 3,
              name: '人脸美妆',
              title: '人脸美妆',
              mj_tool: 'emitFacemakeup',
              guide: '它能够模拟逼真的化妆效果，并通过添加口红、高光、全套妆容以及其他化妆材料来进一步增强面部美化效果。',
              img: require('./img/aiTool/beautify9.webp'),
              points: 1,
            },
            {
              id: 10,
              relation: 3,
              name: '唇色变换器',
              title: '唇色变换器',
              mj_tool: 'emitLipscolorchanger',
              guide: '它能够模拟逼真的化妆效果，并通过添加口红、高光、全套妆容以及其他化妆材料来进一步增强面部美化效果。',
              img: require('./img/aiTool/beautify10.webp'),
              points: 1,
            },
            {
              id: 11,
              relation: 3,
              name: '人脸修复增强',
              title: '人脸修复增强',
              mj_tool: 'emitEnhanceface',
              guide: '自动去除图像中的模糊部分，提升脸部的清晰度和细节。通过AI处理，您可以轻松优化面部图像的质量，使其更加清晰、自然',
              img: require('./img/aiTool/beautify11.webp'),
              points: 1,
            },
          ],
        },

      ],
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    }
  },
  created() {
    this.arrange = this.$route.query.arrange
    this.relation = this.$route.query.relation

  },
  methods: {
    gotool() {
      if(this.$route.query.relation!=3){
        this.$router.push('/toollist')
      }else if(this.$route.query.relation==3){
        this.$router.push('/comeBeautiful')
      }
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.tool_page {
  width: 100%;
  height: calc(100% - 50px);
  background: #313338;
  overflow-y: auto;
  white-space: nowrap;
  text-overflow: ellipsis;

  .item {
    width: 100%;
    margin-top: 40px;

    .page_name {
      width: 100%;
      height: 40px;
      padding: 10px 0;
      text-align: center;
      position: fixed;
      top: 50px;
      left: 0;
      background: rgb(30, 31, 34);
      border-top: 1px solid #333;
      z-index: 99999;

      span {
        color: #5865f2;
        border-bottom: 2px solid #5865f2;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }

      div {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%); /* 向上移动元素自身高度的一半 */
      }
    }

    .page_name:before {

    }
  }

  //.el-tabs{
  //  display: flex;
  //  flex-direction: column;
  //  height: 100%;
  //  :deep(.el-tabs__header){
  //    margin-bottom: 0;
  //    .el-tabs__nav-scroll{
  //      display: flex;
  //      justify-content: center;
  //    }
  //    .el-tabs__nav-wrap:after {
  //      background-color: #555 !important;
  //    }
  //    .el-tabs__active-bar {
  //      background-color: #5865f2 !important;
  //    }
  //    .el-tabs__item {
  //      color: #fff;
  //      &.is-active {
  //        color: #5865f2 !important;
  //      }
  //    }
  //  }
  //  :deep(.el-tabs__content){
  //    flex: 1;
  //  }
  //}
  .pane_item {
    height: 100%;
  }
}
</style>